const Contact = () => {
    
    return (
        <div className="container component contact">
            <div className="contact-area">
                <span>Kumar Desai</span> 
                <span><a href="mailto:kumardesai123@gmail.com">kumardesai123@gmail.com</a></span> 
            </div>
        </div>
    );
}

export default Contact;